$(document).ready(function() {
  // When the user clicks on <span> (x), close the modal
  document.getElementById("request_more-modal-close").onclick = function() {
    document.getElementById('requestMoreModal').style.display = "none";
  }

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    if (event.target == document.getElementById('requestMoreModal')) {
        document.getElementById('requestMoreModal').style.display = "none";
    }
  }
  
  // When the user clicks on <span> (x), close the modal
  document.getElementById("success-modal-close").onclick = function() {
    document.getElementById('successModal').style.display = "none";
  }

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    if (event.target == document.getElementById('successModal')) {
        document.getElementById('successModal').style.display = "none";
    }
  }
  
  // PULL URL QUERY AND ASSIGN
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  // shape
  var shape = "Circle";
  if (urlParams.has('shape')) {
    shape = urlParams.get('shape');
    document.getElementById("shape").value = shape;
    updateOptions();
  }

  // MATERIAL
  var material = 'titanium';
  if (urlParams.has('material')) {
    var material = urlParams.get('material');
    document.getElementById("material").value = material;
  }

  // FIRST FINISH
  if (urlParams.has('first_finish')) {
    var firstFinish = urlParams.get('first_finish');
    document.getElementById("first_finish").value = firstFinish;
  }

  // SECOND FINISH
  if (urlParams.has('second_finish')) {
    var secondFinish = urlParams.get('second_finish');
    document.getElementById("second_finish").value = secondFinish;
  }

  // RING SIZE
  if (urlParams.has('ring_size')) {
    var ringSize = urlParams.get('ring_size');
    document.getElementById("ring_size").value = ringSize;
  }

  // SIGNET SIZE
  if (urlParams.has('signet_size')) {
    var signetSize = urlParams.get('signet_size');
    document.getElementById("signet_size").value = signetSize;
  }

  // SHANK
  if (urlParams.has('shank')) {
    var shank = urlParams.get('shank');
    document.getElementById("shank").value = shank;
  }

  // INLAY MATERIAL
  if (urlParams.has('inlay_material')) {
    var inlayMaterial = urlParams.get('inlay_material');
    document.getElementById("inlay_material").value = inlayMaterial;
  }

  // INLAY FINISH
  if (urlParams.has('inlay_finish')) {
    var inlayFinish = urlParams.get('inlay_finish');
    document.getElementById("inlay_finish").value = inlayFinish;
  }

  // DESIGN PATTERN
  if (urlParams.has('design')) {
    var designPattern = urlParams.get('design');
    document.getElementById("design").value = designPattern;
  }
  
  updateAll("shape", shape, "none");

  var twoWeeksAway = new Date(Date.now() + 12096e5);
  var dd = twoWeeksAway.getDate();
  var mm = twoWeeksAway.getMonth()+1; //January is 0!
  var yyyy = twoWeeksAway.getFullYear();
  if(dd<10){
    dd='0'+dd
  }
  if(mm<10){
    mm='0'+mm
  }

  twoWeeksAway = yyyy+'-'+mm+'-'+dd;
  document.getElementById("rushDate").setAttribute("min", twoWeeksAway);
});

function getURLQuery() {
  var urlQuery = "https://revolutionjewelry.com/pages/signet-ring-design-tool?";

  // SHAPE
  var shape = document.getElementById("shape").value;
  urlQuery = urlQuery.concat("&shape=");
  urlQuery = urlQuery.concat(shape);
  
  // MATERIAL
  var material = document.getElementById("material").value;
  urlQuery = urlQuery.concat("&material=");
  urlQuery = urlQuery.concat(material);
  
  // FIRST FINISH
  var firstFinish = document.getElementById("first_finish").value;
  urlQuery = urlQuery.concat("&first_finish=");
  urlQuery = urlQuery.concat(firstFinish);
  
  // SECOND FINISH
  var secondFinish = document.getElementById("second_finish").value;
  urlQuery = urlQuery.concat("&second_finish=");
  urlQuery = urlQuery.concat(secondFinish);

  // RING SIZE
  var ringSize = document.getElementById("ring_size").value;
  urlQuery = urlQuery.concat("&ring_size=");
  urlQuery = urlQuery.concat(ringSize);

  // SIGNET SIZE
  var signetSize = document.getElementById("signet_size").value;
  urlQuery = urlQuery.concat("&signet_size=");
  urlQuery = urlQuery.concat(signetSize);

  // SHANK
  var shank = document.getElementById("shank").value;
  urlQuery = urlQuery.concat("&shank=");
  urlQuery = urlQuery.concat(shank);

  // INLAY MATERIAL
  var inlayMaterial = document.getElementById("inlay_material").value;
  urlQuery = urlQuery.concat("&inlay_material=");
  urlQuery = urlQuery.concat(inlayMaterial);

  // INLAY FINISH
  var inlayFinish = document.getElementById("inlay_finish").value;
  urlQuery = urlQuery.concat("&inlay_finish=");
  urlQuery = urlQuery.concat(inlayFinish);

  // DESIGN PATTERN
  var designPattern = document.getElementById("design").value;
  urlQuery = urlQuery.concat("&design=");
  urlQuery = urlQuery.concat(designPattern);
  
  history.replaceState({}, '', urlQuery);
}

function updateAll(name, value, gaType) {
  var selectedOption = document.getElementById(name).value;

  if (selectedOption == value && document.getElementById(name).innerHTML.includes('None')) {
    value = 'None';
  }
  
  updateSelectedOption(name, value);
  updateSelectedImage(name, value);
  updateSelectionField(name, value);
  updateOptions();
  updateCustomImage();
  updateAllSelections();

  checkMaterialDislaimers();
  checkInvoiceSubmit();
}

function checkMaterialDislaimers() {
  var ringMaterial = document.getElementById('material').value;

  var bzDisclaimer = '<li class="disclaimer">Black Zirconium is the darkest metal available; however, it is not pure black and in some lighting it can appear to be dark grey. <a href="/pages/black-zirconium-ring-info" rel="nofollow" target="_blank">Click here to learn more about black zirconium</a>.</li>';
  
  var disclaimers = '<p class="disclaimer">This ring comes with a comfort-fit inside the ring, which means that the center of the ring is true to size and gets slightly larger toward the edges of the ring. The comfort fit makes it easier to get the ring on and off, and fits more comfortably on the finger. Keeping that in mind, some people like to order their ring slightly smaller than their ring size (normally a quarter size smaller), if they like their rings to be snug on their finger.</p>';
  if (ringMaterial == 'Black Zirconium') {
    disclaimers = '<li class="disclaimer">This ring comes with a comfort-fit inside the ring, which means that the center of the ring is true to size and gets slightly larger toward the edges of the ring. The comfort fit makes it easier to get the ring on and off, and fits more comfortably on the finger. Keeping that in mind, some people like to order their ring slightly smaller than their ring size (normally a quarter size smaller), if they like their rings to be snug on their finger.</li>';
  }
  if (ringMaterial == 'Black Zirconium') {
    disclaimers = disclaimers.concat(bzDisclaimer);
  }

  document.getElementById('material_disclaimers').innerHTML = disclaimers;
}

function checkInvoiceSubmit() {
  var notes = document.getElementById('notes');
  var priceEstimate = document.getElementById('price_estimate');
  var ringSize = document.getElementById('ring_size');

  if (notes != null && priceEstimate != null && ringSize != null && notes.value == "" && priceEstimate.value != "Submit Request for Pricing" && ringSize.value != "Other") {
    $('#customInvoice').show();
  } else {
    $('#customInvoice').hide();
  }
}

function updatePrice(src) {
  var origin = document.getElementById('origin').value;
  var rushDate = document.getElementById('rushDate').value;
  var size = document.getElementById('ring_size').value;

  var price = document.getElementById('price');
  var priceSelection = document.getElementById('price_selection');
  var priceEstimate = document.getElementById('price_estimate');
  var salePriceEstimate = document.getElementById('sale_price_estimate');
  var priceWithoutAddonsEstimate = document.getElementById('price_without_addons_estimate');
  var salePriceWithoutAddonsEstimate = document.getElementById('sale_price_without_addons_estimate');
  var ringMaterial = document.getElementById('material').value;

  price.innerText = "---";
  priceSelection.innerText = "---";
  priceEstimate.value = "---";

  $.ajax({
    type: "POST",
    url: "https://custom.stonebrookjewelry.com/revo/signet/get_price.php",
    data: { ext: src, origin: origin, rushDate: rushDate, size: size },
    success: function(returnedData){
      if (returnedData.price != "NAN") {
        if (returnedData.sale_price != returnedData.price) {
          if (Shopify.currency.active == "USD") {
            price.innerHTML = "Price: ".concat("<span class='money' style='color: #333;'>").concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",returnedData.sale_price)).concat("</span> ").concat("<span class='money' style='color: #888; text-decoration: line-through !important; font-weight: 400; font-size: 16px;'>").concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",returnedData.price)).concat("</span>");
            priceSelection.innerHTML = "<span class='money' style='color: #333;'>".concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",returnedData.sale_price)).concat("</span> ").concat("<span class='money' style='color: #888; text-decoration: line-through !important; font-weight: 400; font-size: 16px;'>").concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",returnedData.price)).concat("</span>");
            priceEstimate.value = "$".concat(returnedData.price).concat(" USD");
            salePriceEstimate.value = "$".concat(returnedData.sale_price).concat(" USD");
            priceWithoutAddonsEstimate.value = "$".concat(returnedData.price_without_addons).concat(" USD");
            salePriceWithoutAddonsEstimate.value = "$".concat(returnedData.sale_price_without_addons).concat(" USD");
          } else {
            price.innerHTML = "Price: ".concat("<span class='money' style='color: #333;'>").concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",Math.ceil(parseFloat(returnedData.sale_price) * parseFloat(Shopify.currency.rate)))).concat("</span> ").concat("<span class='money' style='color: #888; text-decoration: line-through !important; font-weight: 400; font-size: 16px;'>").concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",Math.ceil(parseFloat(returnedData.price) * parseFloat(Shopify.currency.rate)))).concat("</span>");
            priceSelection.innerHTML = "<span class='money' style='color: #333;'>".concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",Math.ceil(parseFloat(returnedData.sale_price) * parseFloat(Shopify.currency.rate)))).concat("</span> ").concat("<span class='money' style='color: #888; text-decoration: line-through !important; font-weight: 400; font-size: 16px;'>").concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",Math.ceil(parseFloat(returnedData.price) * parseFloat(Shopify.currency.rate)))).concat("</span>");
            priceEstimate.value = "$".concat(returnedData.price).concat(" USD");
            salePriceEstimate.value = "$".concat(returnedData.sale_price).concat(" USD");
            priceWithoutAddonsEstimate.value = "$".concat(returnedData.price_without_addons).concat(" USD");
            salePriceWithoutAddonsEstimate.value = "$".concat(returnedData.sale_price_without_addons).concat(" USD");
          }
        } else {
          if (Shopify.currency.active == "USD") {
            price.innerHTML = "Price: ".concat("<span class='money'>").concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",returnedData.price)).concat("</span>");
            priceSelection.innerHTML = "<span class='money'>".concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",returnedData.price)).concat("</span>");
            priceEstimate.value = "$".concat(returnedData.price).concat(" USD");
            salePriceEstimate.value = "$".concat(returnedData.price).concat(" USD");
            priceWithoutAddonsEstimate.value = "$".concat(returnedData.price_without_addons).concat(" USD");
            salePriceWithoutAddonsEstimate.value = "$".concat(returnedData.sale_price_without_addons).concat(" USD");
          } else {
            price.innerHTML = "Price: ".concat("<span class='money'>").concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",Math.ceil(parseFloat(returnedData.price) * parseFloat(Shopify.currency.rate)))).concat("</span>");
            priceSelection.innerHTML = "<span class='money'>".concat(window.moneyFormats[Shopify.currency.active].money_format.replace("{{amount}}",Math.ceil(parseFloat(returnedData.price) * parseFloat(Shopify.currency.rate)))).concat("</span>");
            priceEstimate.value = "$".concat(returnedData.price).concat(" USD");
            salePriceEstimate.value = "$".concat(returnedData.price).concat(" USD");
            priceWithoutAddonsEstimate.value = "$".concat(returnedData.price_without_addons).concat(" USD");
            salePriceWithoutAddonsEstimate.value = "$".concat(returnedData.sale_price_without_addons).concat(" USD");
          }
        }

        if (document.getElementById('waiting_to_submit').value == 'true') {
          document.getElementById('waiting_to_submit').value = 'false';
          checkPriceBeforeSubmit();
        }
        
        var src = "https://assets.staging.lashbrookdesigns.com";
        src = src.concat(returnedData.image_src);
        if (src != "") {
          src = src.concat("&watermark=false");
          src = src.concat("&image_size=");
        
          if ($('#mobileCustomImg').first().is(':visible')) {
            document.getElementById("centerLoad").style.display = "block";
          }
          var smallImg = new Image();
          smallImg.src = src.concat("200");
          smallImg.crossOrigin = "Anonymous";
          smallImg.addEventListener("load", function() { drawSmallImage(smallImg); }, false);
        
          if ($('#leftMobileCustomImg').first().is(':visible')) {
            document.getElementById("leftLoad").style.display = "block";
          }
          var smallLeftImg = new Image();
          smallLeftImg.src = src.concat("200").replace("images/1","images/2");
          smallLeftImg.crossOrigin = "Anonymous";
          smallLeftImg.addEventListener("load", function() { drawSmallLeftImage(smallLeftImg); }, false);
        
          if ($('#rightMobileCustomImg').first().is(':visible')) {
            document.getElementById("rightLoad").style.display = "block";
          }
          var smallRightImg = new Image();
          smallRightImg.src = src.concat("200").replace("images/1","images/3");
          smallRightImg.crossOrigin = "Anonymous";
          smallRightImg.addEventListener("load", function() { drawSmallRightImage(smallRightImg); }, false);
        
          document.getElementById("topImgLoad").style.display = "block";
          var canvas = document.getElementById("topImg");
          var ctx = canvas.getContext("2d");
          ctx.fillStyle = "#FFFFFF";
          ctx.fillRect(0, 0, 700, 700);
          var largeImg = new Image();
          largeImg.src = src.concat("700");
          largeImg.crossOrigin = "Anonymous";
          largeImg.addEventListener("load", function() { drawLargeImage(largeImg); }, false);
        
          document.getElementById("imageURL").value = src.concat("700");
        }
      } else {
        price.innerText = "Submit Request for Pricing";
        priceSelection.innerText = "Submit Request for Pricing";
        priceEstimate.value = "Submit Request for Pricing";
        salePriceEstimate.value = "Submit Request for Pricing";
        priceWithoutAddonsEstimate.value = "Submit Request for Pricing";
        salePriceWithoutAddonsEstimate.value = "Submit Request for Pricing";
      }
      checkInvoiceSubmit();
    },
    error: function(XMLHttpRequest, textStatus, errorThrown) {
      price.innerText = "Submit Request for Pricing";
      priceSelection.innerText = "Submit Request for Pricing";
      priceEstimate.value = "Submit Request for Pricing";
      salePriceEstimate.value = "Submit Request for Pricing";
      priceWithoutAddonsEstimate.value = "Submit Request for Pricing";
      salePriceWithoutAddonsEstimate.value = "Submit Request for Pricing";

      console.log("XMLHttpRequest: ");
      console.log(XMLHttpRequest);
      console.log("textStatus: ");
      console.log(textStatus);
      console.log("errorThrown: ");
      console.log(errorThrown);
      checkInvoiceSubmit();
    }
  });
}

function updateAllSelections() {
  updateSelectedOption("shape", document.getElementById("shape").value);
  updateSelectedOption("material", document.getElementById("material").value);
  updateSelectedOption("signet_size", document.getElementById("signet_size").value);
  updateSelectedOption("shank", document.getElementById("shank").value);
  updateSelectedOption("first_finish", document.getElementById("first_finish").value);
  updateSelectedOption("second_finish", document.getElementById("second_finish").value);
  updateSelectedOption("inlay_material", document.getElementById("inlay_material").value);
  updateSelectedOption("inlay_finish", document.getElementById("inlay_finish").value);
  updateSelectedOption("design", document.getElementById("design").value);
  updateSelectedImage("shape", document.getElementById("shape").value);
  updateSelectedImage("material", document.getElementById("material").value);
  updateSelectedImage("signet_size", document.getElementById("signet_size").value);
  updateSelectedImage("shank", document.getElementById("shank").value);
  updateSelectedImage("first_finish", document.getElementById("first_finish").value);
  updateSelectedImage("second_finish", document.getElementById("second_finish").value);
  updateSelectedImage("inlay_material", document.getElementById("inlay_material").value);
  updateSelectedImage("inlay_finish", document.getElementById("inlay_finish").value);
  updateSelectedImage("design", document.getElementById("design").value);
  updateSelectionField("shape", document.getElementById("shape").value);
  updateSelectionField("material", document.getElementById("material").value);
  updateSelectionField("signet_size", document.getElementById("signet_size").value);
  updateSelectionField("shank", document.getElementById("shank").value);
  updateSelectionField("first_finish", document.getElementById("first_finish").value);
  updateSelectionField("second_finish", document.getElementById("second_finish").value);
  updateSelectionField("inlay_material", document.getElementById("inlay_material").value);
  updateSelectionField("inlay_finish", document.getElementById("inlay_finish").value);
  updateSelectionField("design", document.getElementById("design").value);
  updateSelectionField("rush_date", document.getElementById("rushDate").value);
  updateSelectionField("notes", document.getElementById("notes").value);
}

function updateSelectedOption(name, value) {
  var selector = '[name="'.concat(name).concat('"]');
  var selects = $(selector);
  if (selects.length > 0) {
    var select = selects[0];
    var options = select.options;
    for (var opt, j = 0; opt = options[j]; j++) {
      if (opt.value == value) {
        select.selectedIndex = j;
        break;
      }
    }
  }
}

function updateSelectedImage(name, value) {
  var classSelector = '.'.concat(name).concat(' .pattern-image');
  var imageContainers = $(classSelector);
  if (imageContainers.length > 0) {
    for (var i = 0; i < imageContainers.length; i++) {
      if (imageContainers[i].parentElement.getAttribute("data-value") == value) {
        imageContainers[i].style.border = "2px solid #333";
        imageContainers[i].style.padding = "3px";
      } else if (imageContainers[i].parentElement.getAttribute("data-value") != null && imageContainers[i].parentElement.getAttribute("data-value").toLowerCase() != name) {
        imageContainers[i].style.border = "transparent";
        imageContainers[i].style.padding = "5px";
      }
    }
  }
}

function updateSelectionField(name, value) {
  var id = '#'.concat(name).concat("_selection_container");
  var elements = $(id);
  var elementId = name.concat("_selection");
  if (document.getElementById(elementId) != null) {
    var element = document.getElementById(elementId);
    if (value == "") {
      element.innerHTML = "None Selected";
      if (name != "shape" && name != "material") {
        elements.hide();
      }
    } else {
      element.innerHTML = value;
      elements.show();
    }
  }
}

function updateOptions() {
  // Signet Size
  var shape = document.getElementById('shape').value;
  var allSizes = ["Small", "Medium", "Large", "Extra Large"];
  var noSmallSizes = ["Medium", "Large", "Extra Large"];

  var availableSizes = allSizes;
  if (shape == "Hexagon" || shape == "Rectangle") {
    availableSizes = noSmallSizes;
  }
  
  updateSelectOptions("signet_size", availableSizes);
  updateSelectImages("signet_size", availableSizes);
  
  // Shank
  var signetSize = document.getElementById('signet_size').value;
  var allShanks = ["Thin", "Wide"];
  var noCigarShanks = ["Thin", "Wide"];
  var onlyWideShank = ["Wide"];

  var availableShanks = allShanks;
  if (shape == "Horizontal Oval" || shape == "Hexagon" || shape == "Rectangle") {
    availableShanks = noCigarShanks;
  }

  if (shape == "Circle" && signetSize == "Medium") {
    availableShanks = onlyWideShank;
  }
  
  updateSelectOptions("shank", availableShanks);
  updateSelectImages("shank", availableShanks);

  // First Finish
  var material = document.getElementById('material').value;
  var allFinishes = ["Polish", "Satin", "Angle Satin", "Bead Blast", "Sand Blast", "Hammer", "Rock"];
  var bzFinishes = ["Polish", "Satin", "Angle Satin", "Bead Blast", "Hammer", "Rock"];

  var availableFirstFinishes = allFinishes;
  if (material == "Black Zirconium" || material == "Black Titanium") {
    availableFirstFinishes = bzFinishes;
  }
  
  updateSelectOptions("first_finish", availableFirstFinishes);
  updateSelectImages("first_finish", availableFirstFinishes);

  // Second Finish
  var shank = document.getElementById('shank').value;
  var availableSecondFinishes = allFinishes;
  if (material == "Black Zirconium" || material == "Black Titanium") {
    availableSecondFinishes = bzFinishes;
  }

  if (shank == "Cigar") {
    availableSecondFinishes = [""];
    $('#secondFinishContainer').hide();
  } else {
    $('#secondFinishContainer').show();
  }
  
  updateSelectOptions("second_finish", availableSecondFinishes);
  updateSelectImages("second_finish", availableSecondFinishes);

  // Inlay Material
  var inlayMaterials = ["None", "10k White Gold", "10k Yellow Gold", "14k Rose Gold", "14k White Gold", "14k Yellow Gold", "18k Rose Gold", "18k White Gold", "18k Yellow Gold", "Abalone", "Amazonite", "Aventurine", "Baseball Bat", "Black Dinosaur Bone", "Black Titanium", "Black Zirconium", "Blood Stone", "Blood Wood", "Bocote", "Boxelder Burl", "Chrysocolla", "Chrysocopper", "Cobalt Chrome", "Cocobolo", "Darkened Tantalum", "Desert Iron Wood", "Ebony", "Forged Carbon Fiber", "Koa", "Labradorite", "Lapis", "Leopard Wood", "Madagascar Rose Wood", "Malachite", "Maple Burl", "Meteorite", "Natural Oak", "Osage Orange", "Padauk", "Palladium Silver", "Pernambuco", "Pietersite", "Platinum", "Pyinmaburl", "Red Dinosaur Bone", "Red Heart", "Red Jasper", "Rhodochrosite", "Sapele", "Sequoia", "Snake Wood", "Sodalite", "Spalted Tamarind", "Tan Dinosaur Bone", "Tantalum", "Teak", "Thuya Burl", "Tigers Eye", "Titanium", "Walnut", "Washington Blue Jade", "Washington Green Jade", "Wenge", "Whiskey Barrel", "Ziricote"];
  var availableInlayMaterial = inlayMaterials;
  if (shank == "Cigar") {
    availableInlayMaterial = ["None"];
  }
  
  updateSelectOptions("inlay_material", availableInlayMaterial);
  updateSelectImages("inlay_material", availableInlayMaterial);

  // Inlay Finish
  var inlayMaterial = document.getElementById('inlay_material').value;
  var allMetalInlayFinishes = ["Polish", "Satin", "Angle Satin", "Bead Blast", "Sand Blast", "Hammer", "Rock"];
  var bzInlayFinishes = ["Polish", "Satin", "Angle Satin", "Bead Blast", "Hammer", "Rock"];
  var semiPreciousFinishes = ["Semi-Precious Matte", "Semi-Precious Polish"];
  var allMetals = ["10k White Gold", "10k Yellow Gold", "14k Rose Gold", "14k White Gold", "14k Yellow Gold", "18k Rose Gold", "18k White Gold", "18k Yellow Gold", "Black Titanium", "Black Zirconium", "Cobalt Chrome", "Darkened Tantalum", "Palladium Silver", "Platinum", "Tantalum", "Titanium"];
  var allMosaics = ["Amazonite", "Aventurine", "Black Dinosaur Bone", "Blood Stone", "Chrysocolla", "Chrysocopper", "Labradorite", "Lapis", "Malachite", "Pietersite", "Red Dinosaur Bone", "Red Jasper", "Rhodochrosite", "Sodalite", "Tan Dinosaur Bone", "Tigers Eye", "Washington Blue Jade", "Washington Green Jade"]
  var allWoods = ["Baseball Bat", "Blood Wood", "Bocote", "Boxelder Burl", "Cocobolo", "Desert Iron Wood", "Ebony", "Koa", "Leopard Wood", "Madagascar Rose Wood", "Maple Burl", "Natural Oak", "Osage Orange", "Padauk", "Pernambuco", "Pyinmaburl", "Red Heart", "Sapele", "Sequoia", "Snake Wood", "Spalted Tamarind", "Teak", "Thuya Burl", "Walnut", "Wenge", "Whiskey Barrel", "Ziricote"]
  
  var nonStone = false;
  var availableInlayFinishes = allMetalInlayFinishes;
  if (allMosaics.includes(inlayMaterial)) {
    availableInlayFinishes = semiPreciousFinishes;
    if (!document.getElementById("inlay_finish").innerHTML.includes("Matte")) {
      nonStone = true;
    }
  } else if (inlayMaterial == "Black Zirconium" || inlayMaterial == "Black Titanium") {
    availableInlayFinishes = bzInlayFinishes;
  } else if (inlayMaterial == "Abalone" || inlayMaterial == "Forged Carbon Fiber" || inlayMaterial == "Meteorite") {
    availableInlayFinishes = [""];
  } else if (allWoods.includes(inlayMaterial)) {
    availableInlayFinishes = [""];
  }

  if (inlayMaterial == "None") {
    $('#inlay_finish_container').hide();
    availableInlayFinishes = [""];
  } else {
    $('#inlay_finish_container').show();
  }
  
  updateSelectOptions("inlay_finish", availableInlayFinishes);
  updateSelectImages("inlay_finish", availableInlayFinishes);

  if (nonStone) {
      document.getElementById("inlay_finish").value = "Semi-Precious Polish";
  }

  // Design Pattern
  var inlayDesignMaterials = ["None", "10k White Gold", "10k Yellow Gold", "14k Rose Gold", "14k White Gold", "14k Yellow Gold", "18k Rose Gold", "18k White Gold", "18k Yellow Gold", "Black Titanium", "Black Zirconium", "Cobalt Chrome", "Darkened Tantalum", "Palladium Silver", "Platinum", "Titanium", "Tantalum"];
  var designPatterns = ["None", "Trees", "Palm", "Snake Skin", "Navigator", "American Flag", "Abstract 1", "Escher 1", "Claddagh 4"];
  var availableDesignPatterns = designPatterns;

  if (inlayDesignMaterials.includes(inlayMaterial)) {
    
  } else {
    availableDesignPatterns = ["None"];
  }
  if (shank == "Cigar") {
    availableDesignPatterns = ["None"];
  }
  if (shank == "Cigar") {
    availableDesignPatterns = ["None"];
  }
  if (signetSize == "Extra Large") {
    availableDesignPatterns = ["None"];
  }
  
  updateSelectOptions("design", availableDesignPatterns);
  updateSelectImages("design", availableDesignPatterns);
  
  // Ring size
  var standardSizes = ["Send Ring Sizers","3","3.25","3.5","3.75","4","4.25","4.5","4.75","5","5.25","5.5","5.75","6","6.25","6.5","6.75","7","7.25","7.5","7.75","8","8.25","8.5","8.75","9","9.25","9.5","9.75","10","10.25","10.5","10.75","11","11.25","11.5","11.75","12","12.25","12.5","12.75","13","13.25","13.5","13.75","14","14.25","14.5","14.75","15","15.25","15.5","15.75","16","16.25","16.5","16.75","17","17.25","17.5","17.75","18","18.25","18.5","18.75","19","19.25","19.5","19.75","20","20.25","20.5","20.75","21","21.25","21.5","21.75","22","22.25","22.5","22.75","23","23.25","23.5","23.75","24"];
  var availableSizes = standardSizes;

  updateSelectOptions("ring_size", availableSizes);
}

function joinArrays(array1, array2) {
  var joinArray = [];
  var i;
  for (i = 0; i < array1.length; i++) {
    if (array2.includes(array1[i])) {
      joinArray.push(array1[i]);
    }
  }
  return joinArray;
}

function updateSelectOptions(selectId, newOptions) {
  var oldValue = document.getElementById(selectId).value;
  var id = '#'.concat(selectId);
  /* Remove all options from the select list */
  $(id).empty();

  /* Insert the new ones from the array above */
  var i;
  for (i = 0; i < newOptions.length; i++) {
    var select  = document.getElementById(selectId);
    var option = document.createElement("option");
    if (newOptions[i] == "Other" && selectId == "ring_size") {
      option.text = "Other (specify in notes)";
    } else {
      option.text = newOptions[i];
    }
    if ((newOptions[i].includes("Select") || newOptions[i] == "None") && selectId != "inlay_material" && selectId != "design") {
      option.value = "";
    } else {
      option.value = newOptions[i];
    }
    select.add(option);
  }
  if (newOptions.includes(oldValue)) {
    document.getElementById(selectId).value = oldValue;
  } else {
    document.getElementById(selectId).selectedIndex = 0;
  }
}

function updateSelectImages(selectId, newOptions) {
  // Hide all images
  var sectionName = '.'.concat(selectId);
  $(sectionName).hide();

  // Show available images
  var i;
  for (i = 0; i < newOptions.length; i++) {
    if (newOptions[i] != "") {
      var optionName = sectionName.concat('.').concat(newOptions[i]).replace(/ /g,"_").toLowerCase();
      $(optionName).show();
    }
  }
}

function updateCustomImage() {
  var shapes = {"Cushion": "CUSH", "Circle": "CIRC", "Horizontal Oval": "HZOVAL", "Oval": "OVAL", "Hexagon": "HEX", "Rectangle": "REC", "Horizontal Rectangle": "HZREC"};
  var ringMaterials = {"10k Yellow Gold": "10KY", "14k Yellow Gold": "14KY", "18k Yellow Gold": "18KY", "10k White Gold": "10KW", "14k White Gold": "14KW", "18k White Gold": "18KW", "14k Rose Gold": "14KR", "18k Rose Gold": "18KR", "Black Titanium": "Z", "Black Zirconium": "Z", "Cobalt Chrome": "CC", "Inconel": "CC", "Palladium Silver": "SILVER", "Platinum": "PLAT", "Titanium": "T"};
  var ringFinishes = {"None": "", "Polish": "POLISH", "Satin": "SATIN", "Angle Satin": "ANGLESATIN", "Bead Blast": "BEAD", "Sand Blast": "SAND", "Hammer": "HAMMER", "Rock": "ROCK"};
  var signetSizes = {"Small": "SM", "Medium": "MD", "Large": "LG", "Extra Large": "XL"};
  var shanks = {"Thin": "T", "Wide": "W", "Cigar": "CIG"};
  var inlayMaterials = {"10k Yellow Gold": "10KY", "14k Yellow Gold": "14KY", "18k Yellow Gold": "18KY", "10k White Gold": "10KW", "14k White Gold": "14KW", "18k White Gold": "18KW", "14k Rose Gold": "14KR", "18k Rose Gold": "18KR", "Abalone": "ABALONE", "Amazonite": "AMAZONITE", "Aventurine": "AVENTURINE", "Baseball Bat": "HW-BASEBALLBAT", "Black Dinosaur Bone": "BLACKDINOBONE", "Black Titanium": "ZIRCONIUM", "Black Zirconium": "ZIRCONIUM", "Blood Stone": "BLOODSTONE", "Chrysocolla": "CHRYSOCOLLA", "Chrysocopper": "CHRYSOCOPPER", "Cobalt Chrome": "COBALT", "Darkened Tantalum": "TANTALUMNOIR", "Forged Carbon Fiber": "C-FORGEDCF", "Inconel": "COBALT", "Labradorite": "LABRADORITE", "Lapis": "LAPIS", "Malachite": "MALACHITE", "Meteorite": "METEORITE", "Palladium Silver": "SS", "Pietersite": "PIETERSITE", "Platinum": "PT", "Red Dinosaur Bone": "REDDINOBONE", "Red Jasper": "REDJASPER", "Rhodochrosite": "RHODOCHROSITE", "Sodalite": "SODALITE", "Tan Dinosaur Bone": "TANDINOBONE", "Tantalum": "TANTALUM", "Tigers Eye": "TIGERSEYE", "Titanium": "TITANIUM", "Washington Blue Jade": "BLUEJADE", "Washington Green Jade": "GREENJADE", "Blood Wood": "HW-BLOODWOOD", "Bocote": "HW-BOCOTE", "Boxelder Burl": "HW-BOXELDERBURL", "Cocobolo": "HW-NATCOCO", "Desert Iron Wood": "HW-DESERTIRONWOOD", "Ebony": "HW-EBONY", "Koa": "HW-KOA", "Leopard Wood": "HW-LEOPARD", "Madagascar Rose Wood": "HW-MADAGASCARROSEWOOD", "Maple Burl": "HW-MAPLEBURL", "Natural Oak": "HW-NATURALOAK", "Osage Orange": "HW-OSAGEORANGE", "Padauk": "HW-PADAUK", "Pernambuco": "HW-PERNAMBUCO", "Pyinmaburl": "HW-PYINMABURL", "Red Heart": "HW-REDHEART", "Sapele": "HW-SAPELE", "Sequoia": "HW-SEQUOIA", "Snake Wood": "HW-SNAKE", "Spalted Tamarind": "HW-SPALTEDTAMARIND", "Teak": "HW-TEAK", "Thuya Burl": "HW-THUYABURL", "Walnut": "HW-WALNUT", "Wenge": "HW-WENGE", "Whiskey Barrel": "HW-WHISKEYBARREL", "Ziricote": "HW-ZIRICOTE"};
  var inlayFinishes = {"None": "", "Polish": "POLISH", "Satin": "SATIN", "Angle Satin": "ANGLESATIN", "Bead Blast": "BEAD", "Sand Blast": "SAND", "Hammer": "HAMMER", "Rock": "ROCK", "Semi-Precious Matte": "MATTE", "Semi-Precious Polish": "POLISH"};
  var designPatterns = {"None": "", "Abstract 1": "LCVABSTRACT1", "American Flag": "LCVAMERICANFLAG", "Claddagh 4": "LCVCLADDAGH4", "Escher 1": "LCVESCHER1", "Navigator": "LCVNAVIGATOR", "Palm": "LCVPALM", "Snake Skin": "LCVSNAKESKIN", "Trees" : "LCVTREES"};
  
  var shapeInput = document.getElementById("shape");
  var shape = shapes[shapeInput.value];
  var signetSizeInput = document.getElementById("signet_size");
  var signetSize = signetSizes[signetSizeInput.value];
  var shankInput = document.getElementById("shank");
  var shank = shanks[shankInput.value];
  var materialInput = document.getElementById("material");
  var material = ringMaterials[materialInput.value];
  var firstFinishInput = document.getElementById("first_finish");
  var firstFinish = ringFinishes[firstFinishInput.value];
  var secondFinishInput = document.getElementById("second_finish");
  var secondFinish = ringFinishes[secondFinishInput.value];
  var inlayMaterialInput = document.getElementById("inlay_material");
  var inlayMaterial = inlayMaterials[inlayMaterialInput.value];
  var inlayFinishInput = document.getElementById("inlay_finish");
  var inlayFinish = inlayFinishes[inlayFinishInput.value];
  var designPatternInput = document.getElementById("design");
  var designPattern = designPatterns[designPatternInput.value];

  var ringSize = document.getElementById("ring_size").value;
  if (ringSize == '' || ringSize == 'Send Ring Sizers') {
    ringSize = "10";
  }

  var src = "/rings/signet/ring_materials/";
  src = src.concat(material);
  src = src.concat("?ring_finish=");
  if (shankInput.value == "Cigar") {
    src = src.concat(firstFinish);
  } else {
    src = src.concat(firstFinish).concat(",").concat(secondFinish);
  }
  src = src.concat("&shape=");
  src = src.concat(shape);
  src = src.concat("&size=");
  src = src.concat(signetSize);
  src = src.concat("&shank=");
  src = src.concat(shank);
  src = src.concat("&finger_size=");
  src = src.concat(ringSize);

  if (inlayMaterialInput.value != "None" && inlayMaterialInput.value != "" && designPatternInput.value != "None" && designPatternInput.value != "") {
    src = src.concat("&feature_group=G,M");
    src = src.concat("&inlays=");
    src = src.concat(inlayMaterial);
    if (inlayFinishInput.value != "") {
      src = src.concat("_").concat(inlayFinish);
    }
    src = src.concat("&signet_engraving=");
    src = src.concat(designPattern);
    src = src.concat("&cerakote_color=None");
  } else if (inlayMaterialInput.value != "None" && inlayMaterialInput.value != "") {
    src = src.concat("&feature_group=G");
    src = src.concat("&inlays=");
    src = src.concat(inlayMaterial);
    if (inlayFinishInput.value != "") {
      src = src.concat("_").concat(inlayFinish);
    }
  } else if (designPatternInput.value != "None" && designPatternInput.value != "") {
    src = src.concat("&feature_group=M");
    src = src.concat("&signet_engraving=");
    src = src.concat(designPattern);
    src = src.concat("&cerakote_color=None");
  } else {
    src = src.concat("&feature_group=N");
  }
  
  // src = src.concat("&watermark=false");

  // console.log("SRC:");
  // console.log(src);

  if ($('#mobileCustomImg').first().is(':visible')) {
    document.getElementById("centerLoad").style.display = "block";
  }
  
  if ($('#leftMobileCustomImg').first().is(':visible')) {
    document.getElementById("leftLoad").style.display = "block";
  }
  
  if ($('#rightMobileCustomImg').first().is(':visible')) {
    document.getElementById("rightLoad").style.display = "block";
  }
  
  document.getElementById("topImgLoad").style.display = "block";
  
  updatePrice(src);
  getURLQuery();
}

function drawSmallImage(img) {
  document.getElementById("centerLoad").style.display = "none";

  var canvas = document.getElementById("mobileCustomImg");
  var ctx = canvas.getContext("2d");
  img.width = 200;
  img.height = 200;
  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(0, 0, 200, 200);
  ctx.drawImage(img, 0, 0, 200, 200);
  ctx.fillRect(150, 180, 200, 200);
}

function drawSmallLeftImage(img) {
  document.getElementById("leftLoad").style.display = "none";

  var canvas = document.getElementById("leftMobileCustomImg");
  var ctx = canvas.getContext("2d");
  img.width = 200;
  img.height = 200;
  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(0, 0, 200, 200);
  ctx.drawImage(img, 0, 0, 200, 200);
  ctx.fillRect(150, 180, 200, 200);
}

function drawSmallRightImage(img) {
  document.getElementById("rightLoad").style.display = "none";

  var canvas = document.getElementById("rightMobileCustomImg");
  var ctx = canvas.getContext("2d");
  img.width = 200;
  img.height = 200;
  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(0, 0, 200, 200);
  ctx.drawImage(img, 0, 0, 200, 200);
  ctx.fillRect(150, 180, 200, 200);
}

function drawLargeImage(img) {
  document.getElementById("topImgLoad").style.display = "none";

  var canvas = document.getElementById("topImg");
  var ctx = canvas.getContext("2d");
  img.width = 700;
  img.height = 700;
  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(0, 0, 700, 700);
  ctx.drawImage(img, 0, 0, 700, 700);
  ctx.fillRect(525, 630, 700, 700);
}

function drawLargeCenterImage(img) {
  document.getElementById("modalImgLoad").style.display = "none";
  document.getElementById("modalCustomImg").style.display = "block";

  var canvas = document.getElementById("modalCustomImg");
  var ctx = canvas.getContext("2d");
  img.width = 700;
  img.height = 700;
  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(0, 0, 700, 700);
  ctx.drawImage(img, 0, 0, 700, 700);
  ctx.fillRect(525, 630, 700, 700);
}

function drawLargeLeftImage(img) {
  document.getElementById("modalImgLoad").style.display = "none";
  document.getElementById("leftModalCustomImg").style.display = "block";

  var canvas = document.getElementById("leftModalCustomImg");
  var ctx = canvas.getContext("2d");
  img.width = 700;
  img.height = 700;
  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(0, 0, 700, 700);
  ctx.drawImage(img, 0, 0, 700, 700);
  ctx.fillRect(525, 630, 700, 700);
}

function drawLargeRightImage(img) {
  document.getElementById("modalImgLoad").style.display = "none";
  document.getElementById("rightModalCustomImg").style.display = "block";

  var canvas = document.getElementById("rightModalCustomImg");
  var ctx = canvas.getContext("2d");
  img.width = 700;
  img.height = 700;
  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(0, 0, 700, 700);
  ctx.drawImage(img, 0, 0, 700, 700);
  ctx.fillRect(525, 630, 700, 700);
}

function showModal(image) {
  // Get the modal
  var modal = document.getElementById("imageModal");
  var src = document.getElementById("imageURL").value;

  // gtag('event', 'show-modal', {'action': 'click', 'label': image }); 

  document.getElementById("leftModalCustomImg").style.display = "none";
  document.getElementById("modalCustomImg").style.display = "none";
  document.getElementById("rightModalCustomImg").style.display = "none";

  modal.style.display = "block";
  if(image == 'left') {
    document.getElementById("modalImgLoad").style.display = "block";

    var largeLeftImg = new Image();
    src = src.replace("images/1","images/2");
    largeLeftImg.src = src;
    largeLeftImg.crossOrigin = "Anonymous";
    largeLeftImg.addEventListener("load", function() { drawLargeLeftImage(largeLeftImg); }, false);
  } else if (image == 'right') {
    document.getElementById("modalImgLoad").style.display = "block";

    var largeRightImg = new Image();
    src = src.replace("images/1","images/3");
    largeRightImg.src = src;
    largeRightImg.crossOrigin = "Anonymous";
    largeRightImg.addEventListener("load", function() { drawLargeRightImage(largeRightImg); }, false);
  } else {
    document.getElementById("modalImgLoad").style.display = "block";

    var largeImg = new Image();
    largeImg.src = src;
    largeImg.crossOrigin = "Anonymous";
    largeImg.addEventListener("load", function() { drawLargeCenterImage(largeImg); }, false);
  }
}

function hideModal() {
  var modal = document.getElementById("imageModal");

  modal.style.display = "none";
  document.getElementById("leftModalCustomImg").style.display = "none";
  document.getElementById("modalCustomImg").style.display = "none";
  document.getElementById("rightModalCustomImg").style.display = "none";
}

function showAlertModal() {
  var modal = document.getElementById("alertModal");
  modal.style.display = "block";
  setTimeout(function(){ document.getElementById("alertModal").style.display = "none"; }, 5000);
}

function sticky_relocate() {
  var stickyModalSize = 194.2;
  var headerSize = 100;
  var window_top = Math.round($(window).scrollTop());
  var div_top = $('.pattern-heading').eq(0).offset().top;
  if (window_top > (div_top - stickyModalSize)) {
    document.getElementById("leftMobileCustomImg").style.display = "block";
    document.getElementById("leftIconContainer").style.display = "block";
    document.getElementById("leftMagIcon").style.display = "block";
    document.getElementById("mobileCustomImg").style.display = "block";
    document.getElementById("iconContainer").style.display = "block";
    document.getElementById("magIcon").style.display = "block";
    document.getElementById("rightMobileCustomImg").style.display = "block";
    document.getElementById("rightIconContainer").style.display = "block";
    document.getElementById("rightMagIcon").style.display = "block";
    document.getElementById("mobileHeader").style.display = "block";
    document.getElementById("price").style.display = "block";
    document.getElementById("mobileImgContainer").style.height = stickyModalSize + "px";
  } else {
    document.getElementById("leftMobileCustomImg").style.display = "none";
    document.getElementById("leftIconContainer").style.display = "none";
    document.getElementById("leftMagIcon").style.display = "none";
    document.getElementById("mobileCustomImg").style.display = "none";
    document.getElementById("iconContainer").style.display = "none";
    document.getElementById("magIcon").style.display = "none";
    document.getElementById("rightMobileCustomImg").style.display = "none";
    document.getElementById("rightIconContainer").style.display = "none";
    document.getElementById("rightMagIcon").style.display = "none";
    document.getElementById("mobileHeader").style.display = "none";
    document.getElementById("price").style.display = "none";
    document.getElementById("mobileImgContainer").style.height = "0px";
  }

  var i;
  for (i = 0; i < $('.pattern-heading').length; i++) {
    var headingTop = Math.round($('.pattern-heading').eq(i).offset().top);

    if ($('.pattern-heading').eq(i).is(':visible')) {
      if (i + 1 < $('.pattern-heading').length) {
        var nextHeadingTop = Math.round($('.pattern-heading').eq(i + 1).offset().top);

        if (i == 0 && window_top < nextHeadingTop - stickyModalSize) {
          var headerText = $('.pattern-heading')[i].firstElementChild.innerText;
          var collapseText = headerText.trim().replace(/ /g,"-").toLowerCase();
          var collapseField = document.getElementById(collapseText.concat("-collapse-field"));
          if (collapseField != undefined) {
            if (collapseField.classList.contains('icon-down-arrow')) {
              document.getElementById('mobileHeader').innerHTML = '<p>' + headerText + '<span class="shrink-link icon-down-arrow"></span></p>';
            } else {
              document.getElementById('mobileHeader').innerHTML = '<p>' + headerText + '<span class="shrink-link icon-up-arrow"></span></p>';
            }
            document.getElementById('mobileHeader').dataset.section = collapseText;
          } else {
            document.getElementById('mobileHeader').innerHTML = '<p>' + headerText + '<span class="shrink-link"></span></p>';
            document.getElementById('mobileHeader').dataset.section = collapseText;
          }
        } else if (window_top >= headingTop - stickyModalSize && (window_top < nextHeadingTop - stickyModalSize || !$('.pattern-heading').eq(i+1).is(':visible'))) {
          var headerText = $('.pattern-heading')[i].firstElementChild.innerText;
          var collapseText = headerText.trim().replace(/ /g,"-").toLowerCase();
          var collapseField = document.getElementById(collapseText.concat("-collapse-field"));
          if (collapseField != undefined) {
            if (collapseField.classList.contains('icon-down-arrow')) {
              document.getElementById('mobileHeader').innerHTML = '<p>' + headerText + '<span class="shrink-link icon-down-arrow"></span></p>';
            } else {
              document.getElementById('mobileHeader').innerHTML = '<p>' + headerText + '<span class="shrink-link icon-up-arrow"></span></p>';
            }
            document.getElementById('mobileHeader').dataset.section = collapseText;
          } else {
            document.getElementById('mobileHeader').innerHTML = '<p>' + headerText + '<span class="shrink-link"></span></p>';
            document.getElementById('mobileHeader').dataset.section = collapseText;
          }
        }
      } else {
        if (window_top >= headingTop - stickyModalSize) {
          var headerText = $('.pattern-heading')[i].firstElementChild.innerText;
          var collapseText = headerText.trim().replace(/ /g,"-").toLowerCase();
          var collapseField = document.getElementById(collapseText.concat("-collapse-field"));
          if (collapseField != undefined) {
            if (collapseField.classList.contains('icon-down-arrow')) {
              document.getElementById('mobileHeader').innerHTML = '<p>' + headerText + '<span class="shrink-link icon-down-arrow"></span></p>';
            } else {
              document.getElementById('mobileHeader').innerHTML = '<p>' + headerText + '<span class="shrink-link icon-up-arrow"></span></p>';
            }
            document.getElementById('mobileHeader').dataset.section = collapseText;
          } else {
            document.getElementById('mobileHeader').innerHTML = '<p>' + headerText + '<span class="shrink-link right"></span></p>';
            document.getElementById('mobileHeader').dataset.section = collapseText;
          }
        }
      }
    }
  }
}

function changeSection(button) {
  var stickyModalSize = 194.2;
  var window_top = Math.round($(window).scrollTop());
  var prevSection = -1;
  var nextSection = -1;

  // if (button == 'next') {
  //   gtag('event', 'previous-next', {'action': 'next' }); 
  // } else {
  //   gtag('event', 'previous-next', {'action': 'previous' }); 
  // }

  var i;
  for (i = 0; i < $('.pattern-heading').length; i++) {
    var headingTop = Math.round($('.pattern-heading').eq(i).offset().top);

    if ($('.pattern-heading').eq(i).is(':visible')) {
      if (i + 1 < $('.pattern-heading').length) {
        var nextHeadingTop;
        var j;
        for (j = i + 1; j < $('.pattern-heading').length; j++) {
          if ($('.pattern-heading').eq(j).is(':visible')) {
            nextHeadingTop = Math.round($('.pattern-heading').eq(j).offset().top);
            break;
          }
        }

        if (i == 0 && window_top < nextHeadingTop - stickyModalSize) {
          prevSection = -1;
          nextSection = -1;
        } else if (i == 1 && window_top > headingTop - stickyModalSize && window_top < nextHeadingTop - stickyModalSize) {
          prevSection = -1;
          for (j = i + 1; j < $('.pattern-heading').length; j++) {
            if ($('.pattern-heading').eq(j).is(':visible')) {
              break;
            }
          }
          nextSection = j;
        } else if (window_top >= headingTop - stickyModalSize && window_top < nextHeadingTop - stickyModalSize) {
          for (j = i - 1; j > 0; j--) {
            if ($('.pattern-heading').eq(j).is(':visible')) {
              break;
            }
          }
          prevSection = j;
          for (j = i + 1; j < $('.pattern-heading').length; j++) {
            if ($('.pattern-heading').eq(j).is(':visible')) {
              break;
            }
          }
          nextSection = j;
        }
      } else {
        if (window_top >= headingTop - stickyModalSize) {
          for (j = i - 1; j > 0; j--) {
            if ($('.pattern-heading').eq(j).is(':visible')) {
              break;
            }
          }
          prevSection = j;
          nextSection = -1;
        }
      }
    }
  }

  if (button == "previous" && prevSection != -1) {
    var offsetPosition = $('.pattern-heading').eq(prevSection).offset().top - stickyModalSize;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  } else if (button == "next" && nextSection != -1) {
    var offsetPosition = $('.pattern-heading').eq(nextSection).offset().top - stickyModalSize;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }
}

function collapseSectionFromHeader() {
  var sectionName = document.getElementById('mobileHeader').dataset.section;
  collapseSection(sectionName);
}

function collapseSection(sectionName){
  var stickyModalSize = 194.2;
  var topField = document.getElementById("top-collapse-field");
  var mobileHeader = document.getElementById("mobileHeader");

  var collapseFieldName = sectionName.concat("-collapse-field");
  var collapseField = document.getElementById(collapseFieldName);

  var collapseName = sectionName.concat("-collapse");
  var collapse = document.getElementById(collapseName);

  if (collapseField.classList.contains("icon-up-arrow")) {
    // gtag('event', 'collapse-expand', {'action': 'collapse', 'label': sectionName }); 
    $(collapse).hide();
    collapseField.classList.remove('icon-up-arrow');
    collapseField.classList.add('icon-down-arrow');
    if (mobileHeader.innerText.toLowerCase() == collapseField.parentElement.innerText.toLowerCase()) {
      mobileHeader.firstElementChild.firstElementChild.classList.remove('icon-up-arrow');
      mobileHeader.firstElementChild.firstElementChild.classList.add('icon-down-arrow');
    }
    var collapseFieldNameId = "#".concat(collapseFieldName);
    var offsetPosition = $(collapseFieldNameId).offset().top + 39.2 - stickyModalSize;
    window.scrollTo({
      top: offsetPosition,
      behavior: "auto"
    });
  } else {
    // gtag('event', 'collapse-expand', {'action': 'expand', 'label': sectionName });
    $(collapse).show();
    collapseField.classList.remove('icon-down-arrow');
    collapseField.classList.add('icon-up-arrow');
    if (mobileHeader.innerText.toLowerCase() == collapseField.parentElement.innerText.toLowerCase()) {
      mobileHeader.firstElementChild.firstElementChild.classList.remove('icon-down-arrow');
      mobileHeader.firstElementChild.firstElementChild.classList.add('icon-up-arrow');
    }
  }
}

function verifySubmit(e) {
  e.preventDefault();
  var invalidRushDate = false;
  var rushDate = document.getElementById('rushDate').value;
  
  if (rushDate != "") {
    var rushDateDate = new Date(rushDate);
    var minRushDate = document.getElementById('rushDate').getAttribute('min');
    var minRushDateDate = new Date(minRushDate);
    if (rushDateDate < minRushDateDate) {
      invalidRushDate = true;
    }
  }

  var name = document.getElementById('name').value;
  var email = document.getElementById('email').value;
  if (invalidRushDate) {
    var alertMessage = "The rush date cannot be any sooner than two weeks from today.";
    document.getElementById('rushDate').focus();
    alert(alertMessage);
  } else if (name != "" && email != "") {
    grecaptcha.ready(function() {
      grecaptcha.execute('6LeLwI4kAAAAANWEbOpzGXY-pITFa6Qngo4OOiZp', {action: 'sumbitForm'}).then(function(token) {
        document.getElementById("token").value = token;
        document.getElementById("moreInfoForm").submit();
      });
    });
  } else {
    var missingFields = [];
    if (name == "") {
      missingFields.push("name");
    }
    if (email == "") {
      missingFields.push("email");
    }

    if (missingFields.length == 2) {
      var alertMessage = "Please provide your ";
      for (i = 0; i < missingFields.length; i++) {
        var name = missingFields[i];
        document.getElementById(missingFields[i]).style.border = '#a71616 2px solid';
        if (i == (missingFields.length - 1)) {
          alertMessage = alertMessage.concat("and ".concat(name));
        } else {
          alertMessage = alertMessage.concat(name).concat(" ");
        }
      }
      alertMessage = alertMessage.concat(".");
      document.getElementById(missingFields[0]).focus();
      alert(alertMessage);
    } else if (missingFields.length == 1) {
      var name = missingFields[0];
      document.getElementById(missingFields[0]).style.border = '#a71616 2px solid';
      var alertMessage = "Please provide your ".concat(name).concat(".");
      document.getElementById(missingFields[0]).focus();
      alert(alertMessage);
    }
  }
}

function checkPriceBeforeSubmit(event) {
  var priceEstimate = document.getElementById('price_estimate').value;
  if (priceEstimate == "---") {
    document.getElementById('waiting_to_submit').value = 'true';
  } else {
    submitInvoice(event);
  }
}

function submitInvoice() {
  var shape = document.getElementById('shape').value;
  var material = document.getElementById('material').value;
  var signetSize = document.getElementById('signet_size').value;
  var shank = document.getElementById('shank').value;
  var firstRingFinish = document.getElementById('first_finish').value;
  var secondRingFinish = document.getElementById('second_finish').value;
  var inlayMaterial = document.getElementById('inlay_material').value;
  var inlayFinish = document.getElementById('inlay_finish').value;
  var design = document.getElementById('design').value;
  var ringSize = document.getElementById('ring_size').value;
  var rushDate = document.getElementById('rushDate').value;
  var notes = document.getElementById('notes').value;
  var name = document.getElementById('name').value;
  var email = document.getElementById('email').value;
  var origin = document.getElementById('origin').value;
  var priceEstimate = document.getElementById('price_estimate').value;
  var salePriceEstimate = document.getElementById('sale_price_estimate').value;
  var priceWithoutAddOnsEstimate = document.getElementById('price_without_addons_estimate').value;
  var salePriceWithoutAddOnsEstimate = document.getElementById('sale_price_without_addons_estimate').value;
  var imageURL = document.getElementById('imageURL').value;
  var customInvoiceButton = document.getElementById('customInvoice');
  var cartButtonLoad = document.getElementById('cartButtonLoad');
  var cartButtonText = document.getElementById('cartButtonText');
  var invalidRushDate = false;

  if (rushDate != "") {
    var rushDateDate = new Date(rushDate);
    var minRushDate = document.getElementById('rushDate').getAttribute('min');
    var minRushDateDate = new Date(minRushDate);
    if (rushDateDate < minRushDateDate) {
      invalidRushDate = true;
    }
  }

  if (invalidRushDate) {
    var alertMessage = "The rush date cannot be any sooner than two weeks from today.";
    document.getElementById('rushDate').focus();
    alert(alertMessage);
  } else if (ringSize != "") {
    grecaptcha.ready(function() {
      grecaptcha.execute('6LeLwI4kAAAAANWEbOpzGXY-pITFa6Qngo4OOiZp', {action: 'sumbitForm'}).then(function(token) {
        document.getElementById("token").value = token;
        
        customInvoiceButton.disabled = true;
        customInvoiceButton.style.backgroundColor = "#777";
        cartButtonText.style.display = "none";
        cartButtonLoad.style.display = "inline-block";
        showLoadingModal();
    
        $.ajax({
          type: "POST",
          url: "https://custom.stonebrookjewelry.com/revo/signet/product_submit.php",
          data: { shape: shape, material: material, signet_size: signetSize, shank: shank, first_finish: firstRingFinish, second_finish: secondRingFinish, inlay_material: inlayMaterial, inlay_finish: inlayFinish, design: design, ring_size: ringSize, rushDate: rushDate, notes: notes, name: name, email: email, origin: origin, price_estimate: priceEstimate, sale_price_estimate: salePriceEstimate, price_without_addons_estimate: priceWithoutAddOnsEstimate, sale_price_without_addons_estimate: salePriceWithoutAddOnsEstimate, imageURL: imageURL, token: token },
          success: function(returnedData){
            // Do something on success
            var customInvoiceButton = document.getElementById('customInvoice');
    
            customInvoiceButton.disabled = false;
            customInvoiceButton.style.backgroundColor = "#557373";
    
            if (returnedData.success == "true") {
              const randNum = Math.floor(Math.random() * 1000000000);
              var items = "{\"items\":[";
              // Ring
              items = items + "{\"id\":" + returnedData.id + ",\"quantity\":1,\"properties\":{\"Ring Size\":\"" + ringSize + "\",\"_iid\":\"" + randNum + "\"}}";
              // Rush
              if (rushDate != "") {
                const rushId = 1081924744;
                items = items + ",{\"id\":" + rushId + ",\"quantity\":1,\"properties\":{\"Ring\":\"" + returnedData.title + "\", \"Rush Date\":\"" + rushDate + "\",\"_iid\":\"" + randNum + "\"}}";
              }
              // Ring Sizers
              if (ringSize == "Send Ring Sizers") {
                const ringSizersId = 12840612102216;
                items = items + ",{\"id\":" + ringSizersId + ",\"quantity\":1,\"properties\":{\"Ring\":\"" + returnedData.title + "\",\"_iid\":\"" + randNum + "\"}}";
              }
              items = items + "]}";

              setTimeout(() => {
                fetch(window.Shopify.routes.root + 'cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: items
                })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    window.location.href = '/cart';
                    return response.json();
                })
                .catch((error) => {
                  closeLoadingModal();
                  console.error('Error:', error);
                  document.getElementById('submitError').style.display = "block";
                  showRequestMoreModal();
                });
              }, 8000);
            } else {
              closeLoadingModal();
              document.getElementById('submitError').style.display = "block";
              showRequestMoreModal();
            }
          },
          error: function(XMLHttpRequest, textStatus, errorThrown) {
            // Do something on error
            customInvoiceButton.disabled = false;
            customInvoiceButton.style.backgroundColor = "#557373";
    
            console.log("XMLHttpRequest: ");
            console.log(XMLHttpRequest);
            console.log("textStatus: ");
            console.log(textStatus);
            console.log("errorThrown: ");
            console.log(errorThrown);
    
            alert("There was an issue sending your request. Please try again.");
          }
        });
      });
    });
  } else {
    var missingFields = [];
    if (ringSize == "") {
      missingFields.push("ring_size");
    }

    if (missingFields.length == 4 || missingFields.length == 3) {
      var alertMessage = "Please provide your ";
      for (i = 0; i < missingFields.length; i++) {
        var name = missingFields[i];
        if (name == "ring_size") {
          name = "ring size";
        }
        document.getElementById(missingFields[i]).style.border = '#a71616 2px solid';
        if (i == (missingFields.length - 1)) {
          alertMessage = alertMessage.concat("and ".concat(name));
        } else {
          alertMessage = alertMessage.concat(name).concat(", ");
        }
      }
      alertMessage = alertMessage.concat(" so we can send the invoice.");
      document.getElementById(missingFields[0]).focus();
      alert(alertMessage);
    } else if (missingFields.length == 2) {
      var alertMessage = "Please provide your ";
      for (i = 0; i < missingFields.length; i++) {
        var name = missingFields[i];
        if (name == "ring_size") {
          name = "ring size";
        }
        document.getElementById(missingFields[i]).style.border = '#a71616 2px solid';
        if (i == (missingFields.length - 1)) {
          alertMessage = alertMessage.concat("and ".concat(name));
        } else {
          alertMessage = alertMessage.concat(name).concat(" ");
        }
      }
      alertMessage = alertMessage.concat(" so we can send the invoice.");
      document.getElementById(missingFields[0]).focus();
      alert(alertMessage);
    } else if (missingFields.length == 1) {
      var name = missingFields[0];
      if (name == "ring_size") {
        name = "ring size";
      }
      document.getElementById(missingFields[0]).style.border = '#a71616 2px solid';
      var alertMessage = "Please provide your ".concat(name).concat(" so we can send the invoice.");
      document.getElementById(missingFields[0]).focus();
      alert(alertMessage);
    }
  }
}

function checkEmpty(name) {
  if (document.getElementById(name).value != "") {
    document.getElementById(name).style.border = '1px solid #cccccc';
  }
}

function checkDislaimers() {
  var rushDate = document.getElementById("rushDate").value;
  var ringSize = document.getElementById("ring_size").value;

  if (rushDate != "" && ringSize == "Send Ring Sizers") {
    document.getElementById("rushSizerDisclaimer").style.display = 'block';
  } else {
    document.getElementById("rushSizerDisclaimer").style.display = 'none';
  }
  if (rushDate != "") {
    document.getElementById("rushInternationalDisclaimer").style.display = 'block';
  } else {
    document.getElementById("rushInternationalDisclaimer").style.display = 'none';
  }
}

function clearRushDate() {
  document.getElementById("rushDate").value = "";
}

$(function() {
  $(window).scroll(sticky_relocate);
  sticky_relocate();
});

function showRequestMoreModal() {
  event.preventDefault();
  document.getElementById('requestMoreModal').style.display = "block";
}

function showSuccessModal() {
  document.getElementById('successModal').style.display = "block";
}

function closeSuccessModalByButton() {
  event.preventDefault();
  document.getElementById('successModal').style.display = "none";
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

function showLoadingModal() {
  document.getElementById('loadingModal').style.display = "block";
}

function closeLoadingModal() {
  document.getElementById('loadingModal').style.display = "none";
}

function goToCartButton() {
  event.preventDefault();
  window.location.href = '/cart/checkout';
}